import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import scroll from "vue3-seamless-scroll";

// Global base styles
import '@/styles/init.css'

// Global theme styles
import '@/styles/theme.scss'

// Rem-based responsive scaling
import "amfe-flexible/index"

// Element Plus UI library
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// Lazy-load directive for images
import Lazyload from "vue3-lazyload";

createApp(App).use(store).use(router).use(ElementPlus).use(Lazyload).use(scroll).mount('#app')
